import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { getUIText } from '../../utils/index';

import { closeDialog } from '../../modules/dialogs';

class ErrorDialog extends React.Component {

  state = {

  }

  render() {
    const {
      app,
      translations,
      dialogs,
      open,

      closeDialog
    } = this.props;

    const {
      data
    } = dialogs ? dialogs : {};

    console.log('data:>>' + data);

    return (
      <Dialog open={open}>
        <DialogTitle>{getUIText('DIALOG_ERROR-TITLE', app.language, translations)} <strong><em>{this.state.name}</em></strong></DialogTitle>
        <DialogContent>
          <DialogContentText>
            {data && data.toString()}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={closeDialog} autoFocus>
            {getUIText('GENERAL-CLOSE', app.language, translations)}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

ErrorDialog.propTypes = {
    app: PropTypes.object,
    translations: PropTypes.object,
    dialogs: PropTypes.object,
  open: PropTypes.any,
  closeDialog: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
      app: state.app,
      translations: state.translations,
      dialogs: state.dialogs,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      closeDialog: () => dispatch(closeDialog()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ErrorDialog);
